





import Vue from 'vue';
export default Vue.extend({
  props: ['currency', 'price', 'priceAdjust'],
  computed: {
    displayCurrency(): string {
      return (this.currency || '').toUpperCase();
    },
  },
});
